<template>
  <modal
    name="openTabOnboarding"
    modal-style="compact"
    :display-header-title="false"
    required
  >
    <open-tab-onboarding />
  </modal>
</template>


<script>
  import OpenTabOnboarding from './open-tab-onboarding/index.vue';


  export default {
    name: 'OpenTabOnboardingModal',

    components: {
      OpenTabOnboarding
    }
  };
</script>
